
import {
    FICHAINDIEDITAR_LOADING,
    FICHAINDIEDITAR_LOADED,
    FICHAINDIEDITAR_ERROR,

    FICHAINDI_LOADING,
    FICHAINDI_LOADED,
    FICHAINDI_ERROR,
    SET_CURRENT_FICHA_ID,

    FICHA_LOADING,
    FICHA_LOADED,
    FICHA_ERROR,

    CREARFICHA_ERROR,
    CREARFICHA_LOADED,
    CREARFICHA_LOADING,

    EDITARFICHA_ERROR,
    EDITARFICHA_LOADED,
    EDITARFICHA_LOADING,

    DELETEFICHA_ERROR,
    DELETEFICHA_LOADED,
    DELETEFICHA_LOADING,

    COLABORADOR_FICHA_ERROR,
    COLABORADOR_FICHA_LOADED,
    COLABORADOR_FICHA_LOADING,

    SIMILITUD_FICHA_ERROR,
    SIMILITUD_FICHA_LOADED,
    SIMILITUD_FICHA_LOADING,

    CREAR_VERSION_FICHA_ERROR,
    CREAR_VERSION_FICHA_LOADED,
    CREAR_VERSION_FICHA_LOADING,
    
    VERSION_FICHA_ERROR,
    VERSION_FICHA_LOADED,
    VERSION_FICHA_LOADING,

    VER_FICHA_ERROR,
    VER_FICHA_LOADED,
    VER_FICHA_LOADING
  } from './../../types/fichatypes';

const INITIAL_STATE = {
    verficha:[],
    verficha_loading: false,
    verficha_loaded: false,
    verficha_error: '',

    isLoading: false,
    fichas: null,
    fichaIndi:[],
    currentFichaId:null,
    fichaIndiEditar : null,
    isLoaded: false,
    crearficha: null,
    colaboradorFicha: [],
    isData: false,
    error: '',
    fichasimilar: null,
    isSimilar: false,

    versionficha: [],
    cversionficha: [],
    loadedV:false,
    createdV: false,
    loadingcV: false,
    errorcV: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case VER_FICHA_LOADING:
            return {
                ... state,
                verficha:[],
                verficha_loading: true,
                verficha_loaded: false,
                verficha_error: '',
            }
        case VER_FICHA_LOADED:
            return {
                ...state,
                verficha:action.payload,
                verficha_loading: false,
                verficha_loaded: true,
                verficha_error: '',
            };
        case VER_FICHA_ERROR:
            return {
                ...state,
                verficha:[],
                verficha_loading: false,
                verficha_loaded: false,
                verficha_error: action.payload,
            }

        case CREAR_VERSION_FICHA_LOADING:
            return {
                ... state,
                loadingcV : true,
                createdV: false,
                errorcV: ''
            }
        case CREAR_VERSION_FICHA_LOADED:
            return {
                ...state,
                cversionficha: action.payload,
                createdV: true,
                loadingcV: false,
                errorcV: '',
            };
        case CREAR_VERSION_FICHA_ERROR:
            return {
                ...state,
                createdV: false,
                loadingcV: false,
                errorcV: action.payload,
            }

        case VERSION_FICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                loadedV: false,
                error: ''
            }
        case VERSION_FICHA_LOADED:
            return {
                ...state,
                versionficha: action.payload,
                loadedV: true,
                isLoading: false,
                error: '',
            };
        case VERSION_FICHA_ERROR:
            return {
                ...state,
                loadedV: false,
                isLoading: false,
                error: action.payload,
            }

        case SIMILITUD_FICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                isSimilar: false,
                error: ''
            }
        case SIMILITUD_FICHA_LOADED:
            return {
                ...state,
                fichasimilar: action.payload,
                isSimilar: true,
                isLoading: false,
                error: '',
            };
        case SIMILITUD_FICHA_ERROR:
            return {
                ...state,
                isLoading: false,
                isSimilar: false,
                error: action.payload,
            }

        case COLABORADOR_FICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                isData: false,
                error: ''
            }
        case COLABORADOR_FICHA_LOADED:
            return {
                ...state,
                colaboradorFicha: action.payload,
                isData: true,
                isLoading: false,
                error: '',
            };
        case COLABORADOR_FICHA_ERROR:
            return {
                ...state,
                isLoading: false,
                isData: false,
                error: action.payload,
            }

        case FICHAINDIEDITAR_LOADING:
            return {
                ... state,
                isLoading : true,
                fichaIndiEditar: null,
                fichaIndi: null,
                fichas: null,
                crearficha: null,
                error: ''
            }
        case FICHAINDIEDITAR_LOADED:
            return {
                ...state,
                fichaIndiEditar: action.payload,
                fichaIndi: null,
                fichas: null,
                crearficha: null,
                error: '',
                isLoading: false
            };
        case FICHAINDIEDITAR_ERROR:
            return {
                ...state,
                fichaIndiEditar: null,
                fichaIndi: null,
                fichas: null,
                crearficha: null,
                isLoading: false,
                error: action.payload,
            }

        case FICHAINDI_LOADING:
            return {
                ... state,
                isLoading : true,
                ffichaIndi: [],
                fichas: null,
                isLoaded: false,
                fichaIndiEditar : null,
                crearficha: null,
                error: ''
            }
        case FICHAINDI_LOADED:
            return {
                ...state,
                fichaIndi: action.payload,
                fichas: null,
                isLoaded: true,
                fichaIndiEditar : null,
                crearficha: null,
                error: '',
                isLoading: false
            };
        case SET_CURRENT_FICHA_ID:
            return {
                ...state,
                currentFichaId: action.payload, // Almacenar el ID actual de la ficha
            };
        case FICHAINDI_ERROR:
            return {
                ...state,
                fichaIndi: [],
                fichas: null,
                fichaIndiEditar : null,
                crearficha: null,
                isLoaded: false,
                isLoading: false,
                error: action.payload,
            }

        case FICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                crearficha: null,
                error: ''
            }
        case FICHA_LOADED:
            return {
                ...state,
                fichas: action.payload,
                fichaIndi: null,
                fichaIndiEditar : null,
                crearficha: null,
                error: '',
                isLoading: false,
            };
        case FICHA_ERROR:
            return {
                ...state,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                crearficha: null,
                isLoading: false,
                error: action.payload,
            }

        case CREARFICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearficha : null,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                error: ''
            }
        case CREARFICHA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearficha: action.payload,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                error: ''
            };
        case CREARFICHA_ERROR:
            return {
                ...state,
                crearficha : null,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                isLoading : false,
                error: action.payload,
            }

        case EDITARFICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearficha : null,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                error: ''
            }
        case EDITARFICHA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearficha: action.payload,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                error: ''
            };
        case EDITARFICHA_ERROR:
            return {
                ...state,
                crearficha : null,
                fichas: null,
                fichaIndi: null,
                fichaIndiEditar : null,
                isLoading : false,
                error: action.payload,
            }

        case DELETEFICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearficha : null,
                error: ''
            }
        case DELETEFICHA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearficha: action.payload,
                error: ''
            };
        case DELETEFICHA_ERROR:
            return {
                ...state,
                crearficha : null,
                isLoading : false,
                error: action.payload,
            }
        default: return state;
    }
}